import type { Ticket } from "../types/ticket";

// Public catalogue supplied for the 4–6 December 2026 race weekend.
// Prices and availability remain subject to change and supplier confirmation.
const importantInformation = [
  "Price and availability are subject to change.",
  "Exact seating, access conditions and fulfilment require supplier confirmation.",
  "Royal Path operates RP Abu Dhabi GP as an independent booking agent for ticket resale.",
];

export const paddockOffer: Ticket = {
  id: "paddock-experience-2026",
  slug: "abu-dhabi-paddock-experience",
  category: "paddock",
  name: "Abu Dhabi Paddock Experience",
  shortName: "Paddock Experience",
  description: "Explore one dedicated Paddock offer with Royal Path. Request the exact access, hospitality and booking details before you commit.",
  grandstand: "Paddock experience · exact access subject to confirmation",
  accessDays: "Subject to confirmation",
  eventDate: "2026 race weekend · access dates subject to confirmation",
  venue: "Yas Marina Circuit, Abu Dhabi",
  price: 115000,
  priceBasis: "Guest count and price basis subject to confirmation",
  currency: "AED",
  availability: "on-request",
  image: "/images/ticket-paddock.svg",
  inclusions: ["Access days and areas subject to confirmation", "Hospitality inclusions subject to confirmation", "Guest count and price basis subject to confirmation"],
  highlights: ["One dedicated Paddock offer", "WhatsApp availability enquiries", "Written itemised quote before payment"],
  importantInformation: [...importantInformation, "No specific Paddock access, driver appearances, garage tours, seating, catering or other benefits are guaranteed by this listing.", "The listed AED 115,000 is not stated as a per-person or group total. Guest count, price basis, access dates, inclusions, taxes and fees must be confirmed in a written quote before payment."],
  featured: false,
};

export const tickets: Ticket[] = [
  {
    id: "west-straight-2026",
    slug: "west-straight-grandstand",
    category: "ticket",
    name: "West Straight Grandstand",
    shortName: "West Straight",
    description: "Three-day grandstand access with a long-track perspective and a lively race-weekend atmosphere.",
    grandstand: "West Straight Grandstand",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 4395,
    currency: "AED",
    availability: "limited",
    image: "https://images.pexels.com/photos/20895329/pexels-photo-20895329.jpeg?auto=compress&cs=tinysrgb&w=1200",
    inclusions: ["Three-day event access", "Reserved grandstand seating", "After-race concert access"],
    highlights: ["Long-track views", "Friday to Sunday access", "Yas Marina atmosphere"],
    importantInformation,
    featured: false,
  },
  {
    id: "marina-2026",
    slug: "marina-grandstand",
    category: "ticket",
    name: "Marina Grandstand",
    shortName: "Marina",
    description: "A three-day grandstand package combining circuit action with the illuminated Yas Marina setting.",
    grandstand: "Marina Grandstand",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 4395,
    currency: "AED",
    availability: "limited",
    image: "https://images.pexels.com/photos/30054758/pexels-photo-30054758.jpeg?auto=compress&cs=tinysrgb&w=1200",
    inclusions: ["Three-day event access", "Reserved grandstand seating", "After-race concert access"],
    highlights: ["Marina backdrop", "Evening race atmosphere", "Friday to Sunday access"],
    importantInformation,
    featured: false,
  },
  {
    id: "north-2026",
    slug: "north-grandstand",
    category: "ticket",
    name: "North Grandstand",
    shortName: "North",
    description: "A high-energy three-day grandstand package with views shaped around braking and cornering action.",
    grandstand: "North Grandstand",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 5595,
    currency: "AED",
    availability: "limited",
    image: "https://images.pexels.com/photos/38712036/pexels-photo-38712036.jpeg?auto=compress&cs=tinysrgb&w=1200",
    inclusions: ["Three-day event access", "Reserved grandstand seating", "After-race concert access"],
    highlights: ["Cornering action", "Elevated sightlines", "Night-race atmosphere"],
    importantInformation,
    featured: false,
  },
  {
    id: "south-2026",
    slug: "south-grandstand",
    category: "ticket",
    name: "South Grandstand",
    shortName: "South",
    description: "Wide-angle circuit views and a vivid marina backdrop across all three competitive race-weekend days.",
    grandstand: "South Grandstand",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 4995,
    currency: "AED",
    availability: "limited",
    image: "https://images.pexels.com/photos/10807493/pexels-photo-10807493.jpeg?auto=compress&cs=tinysrgb&w=1200",
    inclusions: ["Three-day event access", "Reserved grandstand seating", "After-race concert access"],
    highlights: ["Broad track perspective", "Marina atmosphere", "Evening sessions"],
    importantInformation,
    featured: false,
  },
  {
    id: "north-straight-2026",
    slug: "north-straight-grandstand",
    category: "ticket",
    name: "North Straight Grandstand",
    shortName: "North Straight",
    description: "Three-day reserved seating with a straight-line perspective and fast-moving race-weekend action.",
    grandstand: "North Straight Grandstand",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 4900,
    currency: "AED",
    availability: "limited",
    image: "https://images.pexels.com/photos/29252122/pexels-photo-29252122.jpeg?auto=compress&cs=tinysrgb&w=1200",
    inclusions: ["Three-day event access", "Reserved grandstand seating", "After-race concert access"],
    highlights: ["High-speed views", "Three-day programme", "Fan-zone atmosphere"],
    importantInformation,
    featured: false,
  },
  {
    id: "the-house-2026",
    slug: "the-house",
    category: "hospitality",
    name: "The House",
    shortName: "The House",
    description: "A refined three-day hospitality experience designed for comfortable race-weekend viewing and hosting.",
    grandstand: "The House Hospitality",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 7995,
    currency: "AED",
    availability: "limited",
    image: "/images/tab_3_image.jpg",
    inclusions: ["Three-day event access", "Hospitality setting", "Supplier-confirmed service package"],
    highlights: ["Hosted environment", "Premium comfort", "Race-weekend atmosphere"],
    importantInformation,
    featured: false,
  },
  {
    id: "south-club-2026",
    slug: "south-club",
    category: "hospitality",
    name: "South Club",
    shortName: "South Club",
    description: "Club-level race-weekend hospitality paired with a South-side circuit perspective and premium comfort.",
    grandstand: "South Club",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 10095,
    currency: "AED",
    availability: "limited",
    image: "/images/6-426x240px.jpg",
    inclusions: ["Three-day event access", "Club hospitality", "Supplier-confirmed service package"],
    highlights: ["South-side views", "Premium setting", "Three-day experience"],
    importantInformation,
    featured: false,
  },
  {
    id: "terrace-collection-2026",
    slug: "16-360-terrace-collection",
    category: "hospitality",
    name: "16/360 – The Terrace Collection",
    shortName: "16/360 Terrace",
    description: "An elevated terrace hospitality concept for a premium three-day race-weekend experience.",
    grandstand: "The Terrace Collection",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 17995,
    currency: "AED",
    availability: "limited",
    image: "/images/tab_2_image.jpg",
    inclusions: ["Three-day event access", "Terrace hospitality", "Supplier-confirmed service package"],
    highlights: ["Elevated setting", "Premium hosting", "Yas Marina atmosphere"],
    importantInformation,
    featured: false,
  },
  {
    id: "shams-suite-2026",
    slug: "shams-suite-premium-hospitality",
    category: "hospitality",
    name: "Shams Suite – Premium Hospitality",
    shortName: "Shams Suite",
    description: "A premium suite experience for three days of hosted race-weekend entertainment and circuit views.",
    grandstand: "Shams Suite",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 25000,
    currency: "AED",
    availability: "limited",
    image: "/images/tab_1_image.jpg",
    inclusions: ["Three-day event access", "Premium suite hospitality", "Supplier-confirmed service package"],
    highlights: ["Suite environment", "VIP hospitality", "Three-day programme"],
    importantInformation,
    featured: true,
  },
  {
    id: "deck-nine-2026",
    slug: "deck-at-nine-premium-hospitality",
    category: "hospitality",
    name: "Deck at Nine – Premium Hospitality",
    shortName: "Deck at Nine",
    description: "Premium deck hospitality with a distinctive Yas Marina setting across the three-day race weekend.",
    grandstand: "Deck at Nine",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 25000,
    currency: "AED",
    availability: "limited",
    image: "/images/Deck-At-9-600x338px.jpg",
    inclusions: ["Three-day event access", "Premium deck hospitality", "Supplier-confirmed service package"],
    highlights: ["Deck setting", "VIP hospitality", "Marina atmosphere"],
    importantInformation,
    featured: true,
  },
  {
    id: "deck-two-2026",
    slug: "deck-at-two-premium-hospitality",
    category: "hospitality",
    name: "Deck at Two – Premium Hospitality",
    shortName: "Deck at Two",
    description: "An exclusive three-day deck hospitality setting combining premium service with race-weekend energy.",
    grandstand: "Deck at Two",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina Circuit, Abu Dhabi",
    price: 25000,
    currency: "AED",
    availability: "limited",
    image: "/images/Deck-at-2-600x300-3.jpg",
    inclusions: ["Three-day event access", "Premium deck hospitality", "Supplier-confirmed service package"],
    highlights: ["Exclusive setting", "VIP hospitality", "Three-day programme"],
    importantInformation,
    featured: true,
  },
  {
    id: "race-weekend-yacht-2026",
    slug: "race-weekend-yacht-charter",
    category: "yacht",
    name: "Race Weekend Yacht Charter",
    shortName: "Yacht Charter",
    description: "A premium 50-foot yacht experience combining trackside views with hosted race-weekend amenities.",
    grandstand: "Yas Marina Yacht",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina, Abu Dhabi",
    price: null,
    currency: "AED",
    availability: "limited",
    image: "https://saber.fra1.cdn.digitaloceanspaces.com/yachts-packages.png",
    inclusions: ["50ft luxury yacht", "Trackside views", "Gourmet catering", "DJ entertainment"],
    highlights: ["Private-yacht setting", "Marina race atmosphere", "Hosted entertainment"],
    importantInformation,
    featured: true,
  },
  {
    id: "vip-superyacht-2026",
    slug: "vip-superyacht-experience",
    category: "yacht",
    name: "VIP Superyacht Experience",
    shortName: "VIP Superyacht",
    description: "A 100-foot-plus superyacht concept with elevated hosting and exclusive race-weekend experiences.",
    grandstand: "Yas Marina Superyacht",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina, Abu Dhabi",
    price: null,
    currency: "AED",
    availability: "limited",
    image: "https://images.pexels.com/photos/33806158/pexels-photo-33806158.jpeg?auto=compress&cs=tinysrgb&w=1200",
    inclusions: ["100ft+ superyacht", "Helicopter transfer", "Celebrity-chef experience", "After-race party"],
    highlights: ["Ultra-luxury setting", "Premium hosting", "Exclusive entertainment"],
    importantInformation,
    featured: true,
  },
  {
    id: "shared-yacht-2026",
    slug: "shared-yacht-package",
    category: "yacht",
    name: "Shared Yacht Package",
    shortName: "Shared Yacht",
    description: "A social luxury-yacht format for guests who want to share the marina race-weekend experience.",
    grandstand: "Yas Marina Shared Yacht",
    accessDays: "Friday–Sunday",
    eventDate: "4–6 December 2026",
    venue: "Yas Marina, Abu Dhabi",
    price: null,
    currency: "AED",
    availability: "limited",
    image: "https://images.pexels.com/photos/5046354/pexels-photo-5046354.jpeg?auto=compress&cs=tinysrgb&w=1200",
    inclusions: ["Shared yacht experience", "Premium bar", "Live entertainment", "Networking atmosphere"],
    highlights: ["Social yacht setting", "Marina views", "Hosted entertainment"],
    importantInformation,
    featured: true,
  },
  paddockOffer,
];

export const featuredTickets = tickets
  .filter((ticket) => ticket.category === "ticket" || ticket.category === "hospitality")
  .sort((a, b) => (b.price ?? 0) - (a.price ?? 0))
  .slice(0, 6)
  .sort((a, b) => (a.price ?? Number.MAX_SAFE_INTEGER) - (b.price ?? Number.MAX_SAFE_INTEGER));

export const featuredYachts = tickets.filter((ticket) => ticket.category === "yacht");

export const getTicketById = (id: string) => tickets.find((ticket) => ticket.id === id);

export const getTicketBySlug = (slug: string) => tickets.find((ticket) => ticket.slug === slug);
